import axios from 'axios';

import { RoleBinding, ListResponse, ApiConfig } from '../types';
import { toSerializedError } from '../errors/utils';

export type ListRoleBindingsResponse = ListResponse<RoleBinding>;
export type ListRoleBindingsParams = {
  tenant_id: string;
  role_ids?: string[];
  user_ids?: string[];
};

export async function listRoleBindings(
  { api_url, headers }: ApiConfig, 
  { tenant_id, role_ids, user_ids }: ListRoleBindingsParams
) {
  try {
    const params = new URLSearchParams();
    if (role_ids) {
      role_ids.forEach((role_id) => params.append('role_id', role_id));
    }
    if (user_ids) {
      user_ids.forEach((user_id) => params.append('user_id', user_id));
    }
    let res = await axios.get<ListRoleBindingsResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/role-bindings', {
      headers,
      params,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type CreateRoleBindingParams = {
  tenant_id: string;
  body: Omit<RoleBinding, 'id'>;
};
export type CreateRoleBindingResponse = {
  id: string;
  request_id: string;
}

export async function createRoleBinding(
  { api_url, headers }: ApiConfig, 
  { tenant_id, body }: CreateRoleBindingParams
) {
  try {
    let res = await axios.post<CreateRoleBindingResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/role-bindings', body, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type DeleteRoleBindingParams = {
  tenant_id: string;
  body: Pick<RoleBinding, 'id'>;
};

export type DeleteRoleBindingResponse = {
  request_id: string;
}

export async function deleteRoleBinding(
  { api_url, headers }: ApiConfig, 
  { tenant_id, body }: DeleteRoleBindingParams
) {
  try {
    let res = await axios.delete<DeleteRoleBindingResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/role-bindings/'+body.id, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}
